export const SITE_LOGO_URL = process.env.REACT_APP_SITE_LOGO_URL ?? "https://jmdgroup.in/assets/images/logo/JMD-logo.png"
